var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolygonscan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "137px",
    height: "121px",
    viewBox: "0 0 137 121",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.50094891%",
    y1: "76.6517183%",
    x2: "94.2824818%",
    y2: "21.2560371%",
    id: "linearGradient-3v-7mugyno-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A726C1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#803BDF",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B3FE4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "url(#linearGradient-3v-7mugyno-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.717,85.2154 L134.212,66.5068 C135.931,65.5161 137,63.6714 137,61.6902 L137,24.2671 C137,22.2888 135.931,20.4411 134.212,19.4505 L101.717,0.741882025 C99.9986,-0.248745975 97.8605,-0.245840975 96.1418,0.741882025 L63.6469,19.4505 C61.9282,20.4411 60.8591,22.2859 60.8591,24.2671 L60.8591,91.1388 L38.0734,104.255 L15.2876,91.1388 L15.2876,64.8974 L38.0734,51.781 L53.1046,60.4323 L53.1046,42.8305 L40.8611,35.7828 C40.0163,35.2976 39.0521,35.042 38.0734,35.042 C37.0946,35.042 36.1304,35.2976 35.2856,35.7828 L2.78777,54.4943 C1.06908,55.485 0,57.3297 0,59.3109 L0,96.7311 C0,98.7094 1.06908,100.557 2.78777,101.548 L35.2827,120.259 C37.0014,121.247 39.1366,121.247 40.8582,120.259 L73.3531,101.551 C75.0718,100.56 76.1409,98.7123 76.1409,96.734 L76.1409,29.8623 L76.5516,29.627 L98.9266,16.7459 L121.712,29.8652 L121.712,56.1037 L98.9266,69.223 L83.9187,60.5833 L83.9187,78.1851 L96.1389,85.2241 C97.8576,86.2118 99.9957,86.2118 101.714,85.2241 L101.717,85.2154 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonscan);
export default __webpack_public_path__ + "static/media/polygonscan.c209d6cbb5398a039febeceb1afd6d60.svg";
export { ForwardRef as ReactComponent };